// Group G1's own words (inputs and the intake planner): the ones the shared label module does not carry. Each quotes
// the line of the vendored glossary or design-system excerpts it comes from; labels.test.mjs checks every quote, that
// the text sits inside it, that nothing is forbidden and that a word waiting for his confirmation is marked pending.

import { defineLabels, template } from "../labels";

const SEG_WORDS = "*Board · Table* · *virtual · onsite · hybrid* · *Internal · External* · *Not Required · Required*";
const SKILL_WORDS = "skill name · *Critical*";
const REASON_WORDS = "*Reason* · *Rationale* · *Reporting category* · *Final notes* · *Decline reason* · *Withdrawal reason*";
const SUGG_WORDS = "*Interview recommendations* · *Debrief preparation* · \"Human decision remains.\"";
const DROP_WORDS = "*Resume upload* · *PDF and DOCX*";
const DROP_ERRORS = "Er three sentences (invalid · password-protected · unreadable)";
const STATE_WORDS = "*Proposed* · *Confirmed* · *Suggested* · *Customized*";
const CGRID_WORDS = "the five values · skill names · round names · *Uncovered*";
const PICK_WORDS = "*Interviewer* · *Replacement* · *owner* · *reviewers*";
const COVERED = "\"All five ROOTS values and required skills must be covered before finalization.\"";
const ROUNDS = "The proposed columns are Sourced · Qualified · In HM Review · Recruiter screen · HM interview · **Final Interview Loop** · Offer.";

/** Words of the G1 inputs: the segmented choices (#19), skill rows (#58), reason box (#77), the pinned field (#78),
 * the drop zone (row 109), the field-state pill (row 110), the coverage grid (row 112), the grip (row 113) and the person pick (row 114). */
export const G1_LABELS = /* @__PURE__ */ defineLabels({
  board: { text: "Board" },
  table: { text: "Table" },
  virtual: { text: "virtual" },
  onsite: { text: "onsite" },
  hybrid: { text: "hybrid" },
  internal: { text: "Internal" },
  external: { text: "External" },
  notRequired: { text: "Not Required" },

  critical: { text: "Critical" },

  reason: { text: "Reason" },
  rationale: { text: "Rationale" },
  reportingCategory: { text: "Reporting category" },
  finalNotes: { text: "Final notes" },
  declineReason: { text: "Decline reason" },
  withdrawalReason: { text: "Withdrawal reason" },
  reasonStored: { text: "Reason stored" },
  requireReason: { text: "Require reason for Hold and Pass." },

  interviewRecommendations: { text: "Interview recommendations" },
  debriefPreparation: { text: "Debrief preparation" },
  humanDecision: { text: "Human decision remains." },

  resumeUpload: { text: "Resume upload" },
  pdfAndDocx: { text: "PDF and DOCX" },
  fileInvalid: { text: "invalid" },
  filePasswordProtected: { text: "password-protected" },
  fileUnreadable: { text: "unreadable" },

  proposed: { text: "Proposed" },
  confirmed: { text: "Confirmed" },
  suggested: { text: "Suggested" },
  customized: { text: "Customized" },

  uncovered: { text: "Uncovered" },
  covered: { text: "covered" },

  sortable: { text: "sortable" },

  replacement: { text: "Replacement" },
  owner: { text: "owner" },
  reviewers: { text: "reviewers" },

  materialChange: { text: "Material panel structure change" 


},

  recruiterScreen: { text: "Recruiter screen" },
  hmInterview: { text: "HM interview" },
});

/**
 * "Skill 2": a skill by its number, where the screen holds no name for it yet. DS §3.4 draws an assigned skill by its
 * name and retires V1's *Skill #n*; until a skill carries its name, his *Skill* (DS #57's lane words) and the number
 * stand in, pending under Q-E15 (asked.ts).
 */
export const SKILL_N = /* @__PURE__ */ template({ text: "Skill {n}" 



});
